export const AccountMainWrapper =
  'mb-0.5 h-full w-full bg-white bg-cover bg-left-top bg-no-repeat bg-fixed lg:p-6 xl:p-12 lg:py-28 2xl:p-28 lg:mb-0 page-bg-image min-h-screen'

export const AccountRowItem = 'flex flex-col lg:flex-row mb-2.5'

export const AccountLeftColumn =
  'bg-white py-7 px-3 lg:py-12 md:px-6 xl:px-16 flex flex-col lg:flex-[0_0_33%] lg:max-w-[33%] lg:mr-2.5 justify-start'

export const AccountLeftColumnHeader = 'justify-center'

export const AccountLeftColumnMenu = 'justify-start'

export const AccountRightColumn =
  'bg-white py-7 px-3 lg:py-12 md:px-6 xl:px-16 flex flex-col lg:flex-[0_0_66%] lg:max-w-[66%] h-fit justify-start'
